import React, { HTMLAttributes } from 'react';
import cn from 'classnames';
import styles from './Section.module.scss';

function Icon({ icon, IconComponent }) {
  if (!icon && !IconComponent) {
    return null;
  }

  return (
    <span className={styles.sectionTitleIconContainer}>
      {IconComponent && !icon && <IconComponent className={styles.sectionTitleIcon} />}
      {icon && !IconComponent && <img className={styles.sectionTitleIcon} src={icon} />}
    </span>
  );
}

export const SectionTitle = ({
  as: Component = 'span',
  children = null,
  spaced = false,
  underline = false,
  icon = null,
  IconComponent = null,
  loading = false,
  className = null,
  listItem = false,
  ...props
}: any) => (
  <span
    className={cn(styles.sectionTitle, className, {
      [styles.sectionTitleSpaced]: spaced,
      [styles.sectionTitleUnderlined]: underline,
      [styles.sectionTitleListItem]: listItem,
    })}
  >
    <Icon icon={icon} IconComponent={IconComponent} />
    <Component {...props}>{children}</Component>
  </span>
);

export const Section = ({ className, children, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div {...props} className={cn(styles.section, className)}>
    {children}
  </div>
);
